import React from 'react';
import PropTypes from 'prop-types';
import { MemberCard } from '../Dashboard/components/Member/MemberCard';
import {
    VOTE_YES,
    VOTE_NO,
    VOTE_ABSTAIN,
    VOTE_PENDING,
} from '../../../helpers/constants';
import { getVoteResultPlaceholderText } from '../../../helpers/messageText';
import store from '../../../stores/store';

class VoteResult extends React.Component {
    constructor() {
        super();

        this.state = {
            filter: VOTE_YES,
        };
    }

    toggleCollapsed = () => {
        this.setState({ collapsed: !this.state.collapsed });
    };

    toggleFilter = filter => {
        this.setState({ filter: filter });
    };

    getFilteredVoteResults = () => {
        const vote = this.props.vote;

        if(vote.VoteResults === null) {   
             return null;
        }
        
        const filteredVoteResults = vote.VoteResults.filter(result => {
            return result.ResultConstant === this.state.filter;  // TO DO AtendeeConstant
        });
        

		//make sure the groups have loaded before working with the members
		if(this.props.loadingGov && store.groups.selectedGroup !== null) {
	        filteredVoteResults.forEach(result => {
                let members = store.groups.selectedGroup.Members;
	            members.forEach(function(member) {
                    if (member.UserId === result.UserId) {
                        result.Phone2 = member.Phone2
                    }

	                if(member.localAvatarUrl !== undefined && member.localAvatarUrl !== null && member.UserId === result.UserId) {
	                    result.localAvatarUrl = member.localAvatarUrl;
	                }
	            });
	        });
        }

        return filteredVoteResults;
    };

    render() {
        const filteredVoteResults = this.getFilteredVoteResults();

        return (
            <div id="attendees-accordion" role="tablist" aria-multiselectable="true">
                <div
                    id="attendees-content"
                    className="hide collapse show"
                    role="tabpanel"
                    aria-labelledby="headingOne"
                    aria-expanded="true"
                >
                    <div className="pl-2 pr-2 pb-2 pt-0">
                        <div
                            className="mb-2"
                            data-toggle="buttons"
                            role="group"
                            aria-label="Meeting cards options"
                            id="attendee-btn-grp"
                        >
                            <div className="d-flex flex-wrap btn btn-group p-0 mb-2" role="tablist">
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === VOTE_YES ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    aria-pressed="false"
                                    aria-expanded="true"
                                    onClick={() => this.toggleFilter(VOTE_YES)}
                                >
                                    YES
                                </a>
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === VOTE_NO ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.toggleFilter(VOTE_NO)}
                                >
                                    No
                                </a>
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === VOTE_ABSTAIN ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.toggleFilter(VOTE_ABSTAIN)}
                                >
                                    Abstain
                                </a>
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === VOTE_PENDING ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.toggleFilter(VOTE_PENDING)}
                                >
                                    Pending
                                </a>
                            </div>
                            <div className="tab-content d-flex" id="attendee-list">
                                <div
                                    className="tab-pane w-100 active"
                                    id="attending"
                                    role="tabpanel"
                                >
                                    <div className="d-flex flex-wrap justify-content-center">
                                        <div className="row w-100">
                                            {filteredVoteResults !== null && filteredVoteResults.length > 0 ? (
                                                filteredVoteResults.map((detail, index) => (
                                                    <MemberCard key={index} detail={detail} />
                                                ))
                                            ) : (
                                                <div className="pl-2">
                                                    {getVoteResultPlaceholderText(this.state.filter)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

VoteResult.propTypes = {
    vote: PropTypes.object.isRequired,
    loadingGov: PropTypes.bool.isRequired
};

export default VoteResult;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Vote/VoteResult.js